import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { fontRamp } from "@faire/web--source/slate/Typography/Themes";
// TODO: import this from faire/web once it's exported from a server compatible file
export var variantTagMap = {
    displayXLSerifRegular: "h1",
    displayLSerifRegular: "h2",
    displayMSerifRegular: "h3",
    displaySSansSemiBold: "h4",
    displaySSansRegular: "h4",
    displaySSerifRegular: "h4",
    pageHeaderSerifRegular: "h4",
    sectionHeaderSansMedium: "h5",
    subheadingSansRegular: "h5",
    subheadingSansMedium: "h5",
    paragraphSansRegular: "p",
    paragraphSansMedium: "p",
    labelSansRegular: "p",
    labelSansMedium: "p"
};
/**
 * pure function that formats fontRamp's styles from kebab-case to camelCase
 */ var formatFontRamp = function() {
    var result = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(fontRamp.fonts)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _sliced_to_array(_step.value, 2), _key = _step_value[0], value = _step_value[1];
            var key = _key;
            var style = {};
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = Object.entries(value)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var _step_value1 = _sliced_to_array(_step1.value, 2), styleKey = _step_value1[0], styleValue = _step_value1[1];
                    var newStyleKey = styleKey.replace(/-([a-z])/g, function(g) {
                        return g[1].toUpperCase();
                    });
                    style[newStyleKey] = styleValue;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            result[key] = style;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
};
export var FONT_RAMP = formatFontRamp();
